import { FlagIcon } from '@/shared/assets/icons/flags/flag-icon';
import { TLanguageOption } from '@/shared/features/language-switcher/language-switcher.types';
import { LANGUAGES } from '@/shared/features/language-switcher/languages.constants';

export const LANGUAGE_OPTIONS: TLanguageOption[] = LANGUAGES.map(
  ({ code, FlagArt, sortLabel }) => ({
    code,
    flag: (
      <FlagIcon>
        <FlagArt />
      </FlagIcon>
    ),
    sortLabel,
  }),
);
